import Image, { getImageProps } from "next/image";

type Props = {
  image: string;
  image_mobile?: string;
  title: string;
  tag: string;
};

const CarouselCard = ({ image, image_mobile, title, tag }: Props) => {
  const imageMobile = getImageProps({
    src: image_mobile || image,
    alt: title || "image",
    width: 350,
    height: 350,
    sizes: "(max-width: 767px) 100vw, 0px",
    className: "w-full h-full block rounded-none",
    style: { objectFit: "cover" },
    loading: "lazy",
  });
  return (
    <div className=" h-full">
      <picture>
        <source
          media="(max-width: 767px)"
          srcSet={imageMobile.props.srcSet}
          sizes={imageMobile.props.sizes}
        />
        <Image
          src={image}
          alt="image"
          width={800}
          height={550}
          className="w-full h-full block rounded-none"
          style={{ objectFit: "cover" }}
          loading="lazy"
        />
      </picture>

      <div className="slide-content absolute left-0 w-full bottom-0 py-7 px-[30px] xl:py-[38px] xl:px-10 invisible opacity-0 transition-all duration-500">
        <h2 className="title text-xl sm:text-2xl font-medium text-text-fixed-2 uppercase leading-none">
          {title}
        </h2>
        <span className="tag text-xs font-normal uppercase text-text-fixed-2 inline-block leading-none mt-[10px]">
          {tag}
        </span>
      </div>
    </div>
  );
};

export default CarouselCard;
